module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache.13b4949d996012c5741cda47e3183add.png";